import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text } from 'components/Typography'

export const SRadioContainer = styled.label<{ isReadOnly?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  pointer-events: ${({ isReadOnly }) => (isReadOnly ? 'none' : 'unset')};
`

export const SRadioInput = styled.input`
  position: absolute;
  pointer-events: none;
  opacity: 0;
`

export const SRadioCircle = styled.div<{ invalid?: boolean }>`
  border: 2px solid var(--c-gray500);
  border-radius: 100%;
  width: 1.5rem;
  height: 1.5rem;
  flex-basis: 1.5rem;
  flex-shrink: 0;
  background: white;
  color: #a7a7a7;
  cursor: pointer;

  margin-right: 0.75rem;

  display: flex;
  align-items: center;
  justify-content: center;

  &:after {
    content: '';

    width: 0.75rem;
    height: 0.75rem;
    background: var(--c-blue500);
    border-radius: 100%;

    opacity: 0;
    transition: opacity 0.2s;
  }

  input:focus + & {
    box-shadow: 0 0 0 3px var(--c-blue100);
  }

  input:checked + & {
    padding: 0;
    border-color: var(--c-blue500);

    &:after {
      opacity: 1;
    }
  }

  input[disabled] + &,
  input[readonly] + & {
    border: 1px solid #adadad;
    background: #adadad;
    cursor: not-allowed;
    color: #d7d7d7;
  }

  ${({ invalid }) => {
    if (invalid) {
      return css`
        input + & {
          border-color: var(--c-red500);
        }
      `
    }

    return null
  }}
`

export const SErrorText = styled(Text)`
  color: var(--c-red500);
  font-size: 0.75rem;
  line-height: 1.5rem;
`
